import { toQueryParams } from "utils/http/params";
import { dataApi } from "./DataService";

const rangeApi = dataApi
  .enhanceEndpoints({addTagTypes: ['range']})
  .injectEndpoints({
    endpoints: (builder) => ({

      getRanges: builder.query({
          query: () => ({
              url: '/ranges'
          })
      }),

      updateRange: builder.mutation({
        query: ({id, body}) => ({
              url: `/ranges/${encodeURIComponent(id)}`,
              method: 'PATCH',
              body: body
          }),

          async onQueryStarted({id, body, currentQueryArgs}, {dispatch, queryFulfilled}) {
            
            const result = dispatch(
              rangeApi.util.updateQueryData('getRanges', currentQueryArgs, (draft) => {
                const item = draft?.body?.items.find(el => el.id === id);
                item && Object.assign(item, body);
              })
            )

            try {
              const { data } = await queryFulfilled;
              dispatch(
                rangeApi.util.updateQueryData('getDevices', currentQueryArgs, (draft) => {
                  const item = draft?.body?.items.find(el => el.id === id);
                  item && Object.assign(item, data.body);
                })
              );
            }
            catch {
              result.undo();
            }
          }
      }),
      
      addRange: builder.mutation({
          
        query: ({body}) => ({
            url: `/ranges`,
            method: 'POST',
            body: body
        }),

        async onQueryStarted({body, currentQueryArgs}, {dispatch, queryFulfilled}) {
          const patchResult = dispatch(
            rangeApi.util.updateQueryData('getRanges', currentQueryArgs, (draft) => {
              draft.body.items.unshift({id: -1, name: body.name, start: body.start, end: body.end, disabled: false});
              draft.body.total++;
            })
          );
          try {
            const { data } = await queryFulfilled;
            dispatch(
              rangeApi.util.updateQueryData('getRanges', currentQueryArgs, (draft) => {
                draft.body.items[0] = data.body;
              })
            );
          }
          catch {
            patchResult.undo();
          }
        }
      }),

      deleteRange: builder.mutation({
        query: ({id}) => ({
          url: `/ranges/${encodeURIComponent(id)}`,
          method: 'DELETE'
        }),
        async onQueryStarted({id, currentQueryArgs}, {dispatch, queryFulfilled}) {
          const result = dispatch(
            rangeApi.util.updateQueryData('getRanges', currentQueryArgs, (draft) => {
              const index = draft.body.items.findIndex(item => item.id === id);
              draft.body.items.splice(index, 1);
              draft.body.total--;
            })
          );
          queryFulfilled.catch((e) => result.undo());    
        }  
      })
    })
});

export const {
  useGetRangesQuery,
  useUpdateRangeMutation,
  useAddRangeMutation,
  useDeleteRangeMutation
} = rangeApi;